__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "uk_borrower_platform_direct_debit";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@testing-library/jest-dom", "6.2.0", () => (__webpack_require__.e(788).then(() => (() => (__webpack_require__(14788))))));
			register("@testing-library/react", "14.1.2", () => (Promise.all([__webpack_require__.e(222), __webpack_require__.e(773), __webpack_require__.e(963)]).then(() => (() => (__webpack_require__(99607))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(418).then(() => (() => (__webpack_require__(41418))))));
			register("operation-diameter", "2.1.6", () => (Promise.all([__webpack_require__.e(858), __webpack_require__.e(335)]).then(() => (() => (__webpack_require__(33858))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(54164))), 1);
			register("react-router-dom", "6.21.2", () => (Promise.all([__webpack_require__.e(276), __webpack_require__.e(773)]).then(() => (() => (__webpack_require__(46276))))));
			register("react", "18.2.0", () => (() => (__webpack_require__(72791))), 1);
			initExternal(32102);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};